import { render, staticRenderFns } from "./CoursesAdmin.vue?vue&type=template&id=270b3902&scoped=true"
import script from "./CoursesAdmin.vue?vue&type=script&lang=js"
export * from "./CoursesAdmin.vue?vue&type=script&lang=js"
import style0 from "./CoursesAdmin.vue?vue&type=style&index=0&id=270b3902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b3902",
  null
  
)

export default component.exports